import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DoctumentationLandingComponent } from './doctumentation-landing/doctumentation-landing.component';
import { EAgreementComponent } from './E-Agreement/e-agreement/e-agreement.component';
import { GStoreComponent } from './G-Store/g-store/g-store.component';
import { BookingComponent } from './Booking/booking/booking.component';
import { BookingHindiComponent } from './Booking/booking-hindi/booking-hindi.component';
import { CreatingProfileComponent } from './Booking/creating-profile/creating-profile.component';
import { CreatingProfileHindiComponent } from './Booking/creating-profile-hindi/creating-profile-hindi.component';
import { DisputesComponent } from './Disputes/disputes/disputes.component';
import { DisputesHindiComponent } from './Disputes/disputes-hindi/disputes-hindi.component';
import { EAgreementHindiComponent } from './E-Agreement/e-agreement-hindi/e-agreement-hindi.component';
import { GStoreHindiComponent } from './G-Store/g-store-hindi/g-store-hindi.component';
import { InvoiceComponent } from './Invoice/invoice/invoice.component';
import { InvoiceHindiComponent } from './Invoice/invoice-hindi/invoice-hindi.component';
import { PayButtonComponent } from './Pay_Button/pay-button/pay-button.component';
import { PayButtonHindiComponent } from './Pay_Button/pay-button-hindi/pay-button-hindi.component';
import { PayGComponent } from './PAY_G/pay-g/pay-g.component';
import { PayGHindiComponent } from './PAY_G/pay-g-hindi/pay-g-hindi.component';
import { EasyCollectComponent } from './Pay_Profile/easy-collect/easy-collect.component';
import { EasyCollectHindiComponent } from './Pay_Profile/easy-collect-hindi/easy-collect-hindi.component';
import { PayProfileComponent } from './Pay_Profile/pay-profile/pay-profile.component';
import { PayProfileHindiComponent } from './Pay_Profile/pay-profile-hindi/pay-profile-hindi.component';
import { SmartCollectComponent } from './Pay_Profile/smart-collect/smart-collect.component';
import { SmartCollectHindiComponent } from './Pay_Profile/smart-collect-hindi/smart-collect-hindi.component';
import { CreateLinkComponent } from './Payment_Link/create-link/create-link.component';
import { CreateLinkHindiComponent } from './Payment_Link/create-link-hindi/create-link-hindi.component';
import { PaymentLinkComponent } from './Payment_Link/payment-link/payment-link.component';
import { PaymentLinkHindiComponent } from './Payment_Link/payment-link-hindi/payment-link-hindi.component';
import { PaymentQrComponent } from './Payment_QR/payment-qr/payment-qr.component';
import { PaymentQrHindiComponent } from './Payment_QR/payment-qr-hindi/payment-qr-hindi.component';
import { PaymentGatewayComponent } from './Payment-Gateway/payment-gateway/payment-gateway.component';
import { PaymentGatewayHindiComponent } from './Payment-Gateway/payment-gateway-hindi/payment-gateway-hindi.component';
import { RefundsComponent } from './Refunds/refunds/refunds.component';
import { RefundsHindiComponent } from './Refunds/refunds-hindi/refunds-hindi.component';
import { TransactionComponent } from './Transactions/transaction/transaction.component';
import { TransactionHindiComponent } from './Transactions/transaction-hindi/transaction-hindi.component';
import { VideoKycComponent } from './Video_KYC/video-kyc/video-kyc.component';
import { VideoKycHindiComponent } from './Video_KYC/video-kyc-hindi/video-kyc-hindi.component';
import { WebIntegrationComponent } from './Web_Integration/web-integration/web-integration.component';
import { WebIntegrationHindiComponent } from './Web_Integration/web-integration-hindi/web-integration-hindi.component';
import { BookingTecketingComponent } from './Booking/booking-tecketing/booking-tecketing.component';
import { CreateProfileMainComponent } from './Booking/create-profile-main/create-profile-main.component';
import { DisputesMainComponent } from './Disputes/disputes-main/disputes-main.component';
import { AgreementComponent } from './E-Agreement/agreement/agreement.component';
import { StoreComponent } from './G-Store/store/store.component';
import { InvoiceMainComponent } from './Invoice/invoice-main/invoice-main.component';
import { ButtonsComponent } from './Pay_Button/buttons/buttons.component';
import { PaygMainComponent } from './PAY_G/payg-main/payg-main.component';
import { MainProfileComponent } from './Pay_Profile/main-profile/main-profile.component';
import { CollectsComponent } from './Pay_Profile/collects/collects.component';
import { SmartComponent } from './Pay_Profile/smart/smart.component';
import { MainLinksComponent } from './Payment_Link/main-links/main-links.component';
import { CreateMainComponent } from './Payment_Link/create-main/create-main.component';
import { PQRComponent } from './Payment_QR/p-qr/p-qr.component';
import { GatewayComponent } from './Payment-Gateway/gateway/gateway.component';
import { MainRefundsComponent } from './Refunds/main-refunds/main-refunds.component';
import { MainTransactionsComponent } from './Transactions/main-transactions/main-transactions.component';
import { KycComponent } from './Video_KYC/kyc/kyc.component';
import { IntegrationComponent } from './Web_Integration/integration/integration.component';
import { PayOutComponent } from './Payout/pay-out/pay-out.component';
import { OnbordingComponent } from './Onboarding/onbording/onbording.component';
import { FeaturesComponent } from './Payg_Features/features/features.component';
import { CouponsComponent } from './Coupons/coupons/coupons.component';
import { PriceComponent } from './Price_Match/price/price.component';
import { SettlementMainComponent } from './Settlement/settlement-main/settlement-main.component';
import { PriceMainComponent } from './Price_Match/price-main/price-main.component';
import { OnboardingMainComponent } from './Onboarding/onboarding-main/onboarding-main.component';
import { PayoutMainComponent } from './Payout/payout-main/payout-main.component';
import { FeaturesMainComponent } from './Payg_Features/features-main/features-main.component';
import { CouponsMainComponent } from './Coupons/coupons-main/coupons-main.component';
import { CreatePayoutMainComponent } from './Payout/create-payout-main/create-payout-main.component';
import { ShareButtonComponent } from './share-button/share-button.component';
import { ReportsMainComponent } from './Report/reports-main/reports-main.component';
import { MerchnatMainComponent } from './Merchant-Dashboard/merchnat-main/merchnat-main.component';
import { PaymentGatewayWorkingComponent } from './Payment-Gateway/payment-gateway-working/payment-gateway-working.component';
import { IntroductionResellerComponent } from './Reseller/Reseller-intro/introduction-reseller/introduction-reseller.component';
import { RegistrationProcessComponent } from './Reseller/Registration-process/registration-process/registration-process.component';
import { LoginWithQrComponent } from './Reseller/login-with-QR/login-with-qr/login-with-qr.component';
import { ManualLoginComponent } from './Reseller/Manual-Login-Process/manual-login/manual-login.component';
import { ResellerIntroMainComponent } from './Reseller/reseller-intro-main/reseller-intro-main.component';
import { RegistrationProcessMainComponent } from './Reseller/registration-process-main/registration-process-main.component';
import { LoginWithQrMainComponent } from './Reseller/login-with-qr-main/login-with-qr-main.component';
import { ManualLoginMainComponent } from './Reseller/manual-login-main/manual-login-main.component';



const routes: Routes = [
    { path: '', redirectTo: 'payment-gateway', pathMatch: 'full' },
     { path: 'e-agrement', component: AgreementComponent },
     { path: 'g-store', component: StoreComponent },
     { path: 'booking-tecketing', component: BookingTecketingComponent },
     { path: 'create-profile', component: CreateProfileMainComponent },
     { path: 'disputes', component: DisputesMainComponent },
     { path: 'invoice', component: InvoiceMainComponent },
     { path: 'pay-button', component: ButtonsComponent },
     { path: 'pay-g', component: PaygMainComponent },
     { path: 'easy-collect', component: CollectsComponent },
     { path: 'pay-profile', component: MainProfileComponent },
     { path: 'smart-collect', component: SmartComponent },
     { path: 'create-link', component: CreateMainComponent },
     { path: 'payment-link', component: MainLinksComponent },
     { path: 'payment-qr', component: PQRComponent },
     { path: 'payment-gateway', component: GatewayComponent },
     { path: 'refunds', component: MainRefundsComponent },
     { path: 'transaction', component: MainTransactionsComponent },
     { path: 'video-kyc', component: KycComponent },
     { path: 'web-integration', component: IntegrationComponent },
     { path: 'pay-out', component: PayoutMainComponent },
     { path : 'create-payout', component: CreatePayoutMainComponent},
     { path: 'onboarding', component: OnboardingMainComponent },
     { path: 'features', component: FeaturesMainComponent },
     { path: 'coupons', component: CouponsMainComponent },
     { path: 'price', component: PriceMainComponent },
     { path: 'settlement', component: SettlementMainComponent },
     { path: 'share-button', component:ShareButtonComponent},
     { path: 'report', component:ReportsMainComponent},
     { path: 'merchant-dashboard', component:MerchnatMainComponent},
     { path: 'payment-gateway-working', component:PaymentGatewayWorkingComponent},
     { path: 'introduction-reseller', component:IntroductionResellerComponent},
     {path: 'registration-process', component:RegistrationProcessComponent},
     { path:'login-with-qr', component:LoginWithQrComponent},
     {path:'manual-login', component:ManualLoginComponent},
     {path:'sales-partner', component:ResellerIntroMainComponent},
     {path:'sales-partner-registration',component:RegistrationProcessMainComponent},
     {path:'sales-partner-QR', component:LoginWithQrMainComponent},
     {path:'sales-partner-manual',component:ManualLoginMainComponent},
     
     



];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
